<template>
    <div>
        <page-header :title="title" :items="items" />

        <div v-if="!editMode || (editMode && tag.id)" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <add-edit-form
                            v-model="tag"
                            :edit-mode="editMode"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div :class="{ 'mb-3': editMode }">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            :edit-mode="editMode"
                            :sections="sections"
                            :item="tag"
                            @on-delete-confirm="onDeleteConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';
import AddEditForm from '@/components/product-tags/AddEditForm';
import ItemInformation from '@/components/elements/ItemInformation';

export default {
    page: {
        title: 'Manage Product Tag'
    },

    validations: {
        tag: {
            name: {
                required
            }
        }
    },

    components: {
        AddEditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: id ? 'Edit product tag' : 'Add product tag',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Product Tags',
                    to: '/product-tags'
                },
                {
                    text: id ? 'Edit' : 'Add',
                    active: true
                }
            ],
            id,
            editMode: !!id,
            tag: {},
            serverErrors: []
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    async created() {
        if (this.editMode) {
            try {
                this.tag = await this.getTag(this.id);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    },

    methods: {
        ...mapActions({
            addTag: 'productTags/store',
            deleteTag: 'productTags/destroy',
            getTag: 'productTags/show',
            updateTag: 'productTags/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                if (!this.editMode) {
                    const added = await this.addTag(this.tag);

                    this.$router.push(`/product-tags/${added.id}/edit`);
                } else {
                    const { updatedAt } = await this.updateTag({
                        id: this.id,
                        data: this.tag
                    });

                    this.tag.updatedAt = updatedAt;

                    this.$toaster('Tag updated!');
                }
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        async onDeleteConfirm() {
            try {
                await this.deleteTag(this.id);

                this.$router.push('/product-tags');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        this.$toasterError(data);

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
